// extracted by mini-css-extract-plugin
export default {"modal":"modal-QrTi9","header":"header-xtdbK","body":"body-mCMPT","section":"section-_uLOt","footer":"footer-vJVU7"};